import { render, staticRenderFns } from "./tableTop.vue?vue&type=template&id=3031260b&scoped=true"
import script from "./tableTop.vue?vue&type=script&lang=js"
export * from "./tableTop.vue?vue&type=script&lang=js"
import style0 from "./tableTop.vue?vue&type=style&index=0&id=3031260b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031260b",
  null
  
)

export default component.exports